<div class="mod-queue">
  @if (isLoading()) {
    <p class="mod-queue__hint">
      {{ 'app.patrol.discord.cockpit.modQueue.loading' | translate }}
    </p>
  } @else if (loadError() === 'load_failed') {
    <p class="mod-queue__error" role="alert">
      {{ 'app.patrol.discord.cockpit.modQueue.loadError' | translate }}
    </p>
  } @else {
    <section class="queue-card">
      <h2 class="section-title">
        {{ 'app.patrol.discord.cockpit.modQueue.title' | translate }}
      </h2>
      <p class="section-hint">
        {{ 'app.patrol.discord.cockpit.modQueue.hint' | translate }}
      </p>

      @if (loadError() === 'action_failed') {
        <p class="mod-queue__error" role="alert">
          {{ 'app.patrol.discord.cockpit.modQueue.actionError' | translate }}
        </p>
      }

      @if (modQueueItems().length > 0) {
        <div class="table-wrap">
          <table class="queue-table">
            <thead>
              <tr>
                <th>{{ 'app.patrol.discord.cockpit.modQueue.columns.case' | translate }}</th>
                <th>{{ 'app.patrol.discord.cockpit.modQueue.columns.time' | translate }}</th>
                <th>{{ 'app.patrol.discord.cockpit.modQueue.columns.user' | translate }}</th>
                <th>{{ 'app.patrol.discord.cockpit.modQueue.columns.action' | translate }}</th>
                <th>{{ 'app.patrol.discord.cockpit.modQueue.columns.tier' | translate }}</th>
                <th>{{ 'app.patrol.discord.cockpit.modQueue.columns.severity' | translate }}</th>
                <th>{{ 'app.patrol.discord.cockpit.modQueue.columns.review' | translate }}</th>
              </tr>
            </thead>
            <tbody>
              @for (item of modQueueItems(); track item.id) {
                <tr>
                  <td><code>{{ item.caseId.slice(0, 8) }}</code></td>
                  <td>{{ formatDate(item.createdAt) }}</td>
                  <td><code>{{ item.platformUserId }}</code></td>
                  <td>
                    <span class="action-badge" [attr.data-action]="item.proposedAction">
                      {{ item.proposedAction }}
                    </span>
                  </td>
                  <td>{{ item.tier }}</td>
                  <td>{{ item.severity }}</td>
                  <td class="queue-actions-cell">
                    <div class="queue-actions">
                      <button
                        type="button"
                        class="queue-actions__btn queue-actions__btn--approve"
                        [disabled]="isBusy(item.id)"
                        (click)="approve(item.id)"
                      >
                        {{
                          'app.patrol.discord.cockpit.modQueue.approve' | translate
                        }}
                      </button>
                      <button
                        type="button"
                        class="queue-actions__btn queue-actions__btn--reject"
                        [disabled]="isBusy(item.id)"
                        (click)="reject(item.id)"
                      >
                        {{
                          'app.patrol.discord.cockpit.modQueue.reject' | translate
                        }}
                      </button>
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      } @else {
        <p class="empty-hint">
          {{ 'app.patrol.discord.cockpit.modQueue.empty' | translate }}
        </p>
      }
    </section>
  }
</div>
